exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contenedorVerGestionOrdenes[data-v-798f8480]{width:100%}.contenedorVerGestionOrdenes .space-bottom[data-v-798f8480]{margin-bottom:10vh}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-798f8480","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./src/components/VerGestionOrdenes/VerGestionOrdenes.scss
// module id = 999
// module chunks = 0